import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlbumsService, ScrollService } from '../../api/';
import { Location } from '@angular/common';

@Component({
  selector: 'app-album-detail',
  templateUrl: './album-detail.component.html',
  styleUrls: ['./album-detail.component.css']
})
export class AlbumDetailComponent implements OnInit {
    private album: any;
    private loading: boolean = true;
    private albumDoesntExist: boolean;
    private songs: Array<any>;
    public creditsArray: any = [];
    public writersArray: any = [];
    checkIfMobile: boolean = false;

    constructor(private location: Location,private route: ActivatedRoute, private albumService: AlbumsService, private scrollService: ScrollService) {
    }

    //back to previous url-- Only for advanced search
    back() {
        this.location.back();
    }
  
    ngOnInit() {
        if (screen.width <= 667) {
            // var btn = document.getElementById("123");
            // btn.click();
            this.checkIfMobile = true;
        }
        this.route.params.subscribe((params) => {
            this.albumService.getAlbumDetailsBySlug(params['albumSlug']).subscribe((res) => {
                this.album = res;
                if(!this.album){
                    this.albumDoesntExist = true;
                }
                if(res.songs) {
                    res.songs.forEach((arrayItem) => {
                        arrayItem.playedFrom = 'album';
                    });
                }
                this.removeSlash(res.songs);
                this.removeDuplicatCredits(res.songs);
                this.loading = false;
                this.scrollService.toggleProgressBar(false);
            },
            (error) => {
                console.log(error);
            });
        });
    }

    removeSlash(songs){
        this.songs = songs;
        if(this.songs){
            for(var i = 0 ;i<this.songs.length;i++) {
                if (typeof this.songs[i].credits === "object" && this.songs[i].credits != null) {
                    for (var j = 0; j < this.songs[i].credits.length; j++) {
                        this.songs[i].credits[j].credit_type = this.songs[i].credits[j].credit_type.replace("_", " ");
                        this.songs[i].credits[j].credit_type = this.songs[i].credits[j].credit_type.charAt(0).toUpperCase() + this.songs[i].credits[j].credit_type.slice(1);
                    }
                }
            }
        }
    }

    removeDuplicatCredits(songs){
        if(this.songs) {
            for (var i = 0; i < this.songs.length; i++) {
                this.writersArray.length = 0;
                this.songs[i].writers.forEach((item, index) => {
                    if (index !== this.songs[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.songs[i].writers[index]);
                        this.songs[i].writers.splice(index, 1);
                    }
                });
                this.songs[i].writers.forEach((item, index) => {
                    if (index !== this.songs[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.songs[i].writers[index]);
                        this.songs[i].writers.splice(index, 1);
                    }
                });
                this.songs[i].writers.forEach((item, index) => {
                    if (index !== this.songs[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.songs[i].writers[index]);
                        this.songs[i].writers.splice(index, 1);
                    }
                });
                this.songs[i].writers.forEach((item, index) => {
                    if (index !== this.songs[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.songs[i].writers[index]);
                        this.songs[i].writers.splice(index, 1);
                    }
                });
                this.creditsArray.length = 0;
                this.songs[i].credits.forEach((item, index) => {
                    if (index !== this.songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.songs[i].credits[index]);
                        this.songs[i].credits.splice(index, 1);
                    }
                });
                this.songs[i].credits.forEach((item, index) => {
                    if (index !== this.songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.songs[i].credits[index]);
                        this.songs[i].credits.splice(index, 1);
                    }
                });
                this.songs[i].credits.forEach((item, index) => {
                    if (index !== this.songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.songs[i].credits[index]);
                        this.songs[i].credits.splice(index, 1);
                    }
                });
                this.songs[i].credits.forEach((item, index) => {
                    if (index !== this.songs[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.songs[i].credits[index]);
                        this.songs[i].credits.splice(index, 1);
                    }
                });
                if (this.creditsArray && this.creditsArray.length) {
                    for (var j = 0; j < this.creditsArray.length; j++) {
                        for (var k = 0; k < this.songs[i].credits.length; k++) {
                            if (this.songs[i].credits[k].credit_type == this.creditsArray[j].credit_type) {
                                if (!(this.songs[i].credits[k].name.includes(this.creditsArray[j].name))) {

                                    if (!this.songs[i].credits[k].values) {
                                        this.songs[i].credits[k]["values"] = [];
                                    }
                                    if (!(this.songs[i].credits[k].values.includes(this.songs[i].credits[k].name))) {
                                        this.songs[i].credits[k].values.push(this.songs[i].credits[k].name);
                                    }
                                    if (!(this.songs[i].credits[k].values.includes(this.creditsArray[j].name))) {
                                        this.songs[i].credits[k].values.push(this.creditsArray[j].name);
                                    }
                                }
                            }
                        }
                    }
                }
                for (var k = 0; k < this.songs[i].credits.length; k++) {
                    if (!this.songs[i].credits[k].values) {
                        this.songs[i].credits[k]["values"] = [];
                    }
                    if (!(this.songs[i].credits[k].values.includes(this.songs[i].credits[k].name))) {
                        var locationPartt = this.songs[i].credits[k].name.split(",");
                        for (var p = 0; p < locationPartt.length; p++) {
                            locationPartt[p].replace(",", "");
                            this.songs[i].credits[k].values.push(locationPartt[p]);
                        }
                    }
                    if (this.songs[i].credits[k].location && this.songs[i].credits[k].location != null) {
                        this.songs[i].credits[k]["locations"] = [];
                        var locationParts = this.songs[i].credits[k].location.split(",");
                        for (var m = 0; m < locationParts.length; m++) {
                            if (!(locationParts[m].includes("."))) {
                                this.songs[i].credits[k].locations.push(locationParts[m]);
                            }
                            else {
                                var locationParts2 = locationParts[m].split(".");
                                for (var n = 0; n < locationParts2.length; n++) {
                                    this.songs[i].credits[k].locations.push(locationParts2[n]);
                                }
                            }
                        }
                    }
                }

                //publisher array making
                if (!this.songs[i].publishers) {
                    this.songs[i]["publisherss"] = [];
                    if (this.songs[i].publisher) {
                        var locationParttt = this.songs[i].publisher.split(",");

                        for (let p = 0; p < locationParttt.length; p++) {
                            locationParttt[p].replace(",", "");
                            this.songs[i].publisherss.push(locationParttt[p]);
                        }
                    }
                } else {
                    this.songs[i]["publisherss"] = [];
                    for (let m = 0; m < this.songs[i].publishers.length; m++) {
                        if (this.songs[i].publishers[m].publisher) {
                            this.songs[i].publisherss.push(this.songs[i].publishers[m].publisher);
                        }
                    }
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/albums/album-detail/album-detail.component.ts